module.exports = __webpack_public_path__ + "static/architecture-a333de522ebb59eacf354a0263e83ee8.svg";